import React from 'react'
import { mapMeasure } from '../../helpers'

/**
 * Componentes de presentación de los filtros de SearchKit compartidos entre el catálogo
 * (`FiltersV2`) y la landing de campañas (`PromotionFilters`).
 *
 * Salieron tal cual del final de FiltersV2.js.
 */

export const ClearFiltersDesktop = ({ hasFilters, translate, resetFilters, onReset }) => (
    <span
        size="small"
        icon="trash"
        hidden={!hasFilters}
        className="clean-filters"
        onClick={() => {
            resetFilters()
            onReset()
        }}
        datacy="catalog__clear_all_filters"
    >
        {translate('reset.clear_all')}
    </span>
)

export const CustomFilterItem = (hasImperialUnits, intl) => ({ filterId, labelKey, labelValue, removeFilter, translate }) => {
    /* SearchKit translations handle its own labels; finish values fall back to the existing React Intl messages. */

    // Define a map to handle logic for different filterIds
    const translateIntlValue = value => {
        if (typeof value !== 'string' || !intl || !intl.messages || !intl.messages[value]) return value
        return intl.formatMessage({ id: value })
    }

    const logicMap = {
        finish: translateIntlValue,
        finishFamily: translateIntlValue,
        zaddon: value => {
            if (value === 'MAL') {
                return translate('yes') || 'Yes'
            } else if (!value) {
                return translate('no') || 'No'
            }
            return value
        },
        outletQuality: value => {
            if (value === 'O') {
                return translate('outlet_o') || 'Outlet Basic'
            } else if (value === 'V') {
                return translate('outlet_v') || 'Outlet Premium'
            } else if (value === 'X') {
                return translate('outlet_x') || 'Outlet Exclusive'
            } else if (value === 'W') {
                return translate('outlet_w') || 'Outlet Premium Plus'
            }
            return value
        },
        commercialFormat: value => {
            return mapMeasure(value, hasImperialUnits)
        }
        /* commercialFormat: (value) => {
            if (value === '') {
                return translate('without_format') || 'Without format'
            }
            return value
        } */
    }

    // Fallback for unknown filterIds or default logic
    const defaultHandler = value => value || ''

    // Get the display label based on the logic map
    const getDisplayLabel = () => {
        if (filterId.startsWith('commercialFormat')) filterId = 'commercialFormat'
        const handler = logicMap[filterId] || defaultHandler
        return handler(labelValue)
    }

    //RESPECT THE HTML STRUCTURE. checkFilters METHOD DEPENDS ON.

    return (
        <div className={`sk-selected-filters-option sk-selected-filters__item selected-filter--${filterId}`}>
            <div className="sk-selected-filters-option__name">
                {labelKey + ': '}
                <span>{getDisplayLabel()}</span>
            </div>
            <div className="sk-selected-filters-option__remove-action" onClick={() => removeFilter()}>
                x
            </div>
        </div>
    )
}
